//
// ItemTitle
//
// A simple component which returns either the formatted label or name
// based on the labelView parameter.

import { observer } from 'mobx-react-lite'
import { useStore } from '../../stores'
import { formatItemTitle } from '../../stores/data/utils'
import { maxChars } from '../../utils/text'

export const ItemTitle = observer(function ItemTitle({
    item,
    ellipsisAfter,
    ...other
}) {
    const { app, view } = useStore()

    const labelView = view.environment.get('labelView')

    // we can use formatItemTitle directly - it is explicitly meant to format an item
    // for this component, even though we can use the formatItemTitle in other places
    // too where we don't want/can't use the full ItemTitle
    let title = formatItemTitle(item, view.language, labelView, app.text('[empty]'))
    let truncatedTitle = maxChars(title, ellipsisAfter)

    return (
        <span className="cc-ItemTitle" title={title} {...other}>
            {truncatedTitle}
        </span>
    )
})
